export const INSTANT_WEBSITE_SETTINGS_ACCEPT_VERSION = '1.0.0';

export interface IInstantWebsiteSettingsData {
  settings: IInstantWebsiteSettings;
}

export interface IInstantWebsiteSettings {
  is_published: boolean;
  url: string;
  business_info: IBusinessInfo;
  social_links: ISocialLinks;
}

export interface IBusinessInfo {
  name: string;
  website: string;
  telephone: string;
  company_address: string;
  email: string;
  description: string;
}

export interface ISocialLinks {
  fb: string;
  instagram: string;
}
